import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { profileApi, authStorage } from "../../../services/apiClient";

const ProfileForm = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      name: "",
      residentialAddress: "",
      city: "",
      province: "",
      postalCode: "",
      skills: "",
    },
  });

  useEffect(() => {
    const loadProfile = async () => {
      const token = authStorage.getToken();
      if (!token) {
        setErrorMessage("Silakan login untuk mengakses profil.");
        setLoading(false);
        return;
      }

      try {
        const response = await profileApi.getMe(token);
        reset({
          name: response.user.name || "",
          residentialAddress: response.user.residentialAddress || "",
          city: response.user.city || "",
          province: response.user.province || "",
          postalCode: response.user.postalCode || "",
          skills: (response.user.skills || []).join(", "),
        });
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [reset]);

  const onSubmit = async (formData) => {
    const token = authStorage.getToken();
    if (!token) {
      setErrorMessage("Sesi login tidak ditemukan.");
      return;
    }

    setSaving(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const payload = {
        name: formData.name,
        residentialAddress: formData.residentialAddress,
        city: formData.city,
        province: formData.province,
        postalCode: formData.postalCode,
        skills: formData.skills
          .split(",")
          .map((skill) => skill.trim())
          .filter(Boolean),
      };

      await profileApi.updateMe(token, payload);
      setSuccessMessage("Profil berhasil diperbarui.");
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p>Memuat data profil...</p>;
  }

  return (
    <form className="user-data-form" onSubmit={handleSubmit(onSubmit)}>
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      {successMessage && (
        <div className="alert alert-success">{successMessage}</div>
      )}

      <div className="row">
        <div className="col-12">
          <div className="input-group-meta mb-25">
            <label>Nama</label>
            <input type="text" {...register("name", { required: true })} />
          </div>
        </div>
        <div className="col-12">
          <div className="input-group-meta mb-25">
            <label>Alamat Tempat Tinggal</label>
            <input type="text" {...register("residentialAddress")} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="input-group-meta mb-25">
            <label>Kota</label>
            <input type="text" {...register("city")} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="input-group-meta mb-25">
            <label>Provinsi</label>
            <input type="text" {...register("province")} />
          </div>
        </div>
        <div className="col-12">
          <div className="input-group-meta mb-25">
            <label>Kode Pos</label>
            <input type="text" {...register("postalCode")} />
          </div>
        </div>
        <div className="col-12">
          <div className="input-group-meta mb-25">
            <label>Skill untuk Berbagi (pisahkan dengan koma)</label>
            <input type="text" {...register("skills")} />
          </div>
        </div>
        <div className="col-12">
          <button type="submit" className="theme-btn-one mt-20" disabled={saving}>
            {saving ? "Menyimpan..." : "Simpan Profil"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ProfileForm;
